module.exports = __webpack_public_path__ + "img/shield.d7bec2ac.png";